<template>
  <div class="tenants-wrap">
    <transition mode="out-in" name="el-fade-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Tenants"
}
</script>

<style scoped lang="scss">
.tenants-wrap {
  width: 100%;
}
</style>
